import React, { Component, PropTypes } from 'react';

class Visa extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="22"
        viewBox="0 0 32 22"
        version="1.1"
        {...this.props}
      >
        <g fillRule="evenodd">
          <rect
            fill="#FFFFFF"
            transform="translate(16.000000, 11.000000) scale(1, -1) translate(-16.000000, -11.000000) "
            x="0"
            y="4"
            width="32"
            height="14"
          />
          <g transform="translate(4.000000, 7.000000)" fill="#1A1F71">
            <path d="M8.42 7.23L9.54 0.15 11.33 0.15 10.21 7.23 8.42 7.23" />
            <path d="M16.71 0.33C16.35 0.19 15.8 0.03 15.1 0.03 13.33 0.03 12.09 0.99 12.07 2.37 12.06 3.39 12.96 3.95 13.64 4.29 14.34 4.64 14.58 4.86 14.57 5.17 14.57 5.65 14.02 5.86 13.5 5.86 12.78 5.86 12.4 5.75 11.81 5.49L11.58 5.38 11.33 6.96C11.75 7.16 12.52 7.33 13.33 7.34 15.21 7.34 16.43 6.39 16.45 4.92 16.45 4.12 15.98 3.5 14.94 3 14.32 2.67 13.93 2.45 13.94 2.12 13.94 1.83 14.26 1.51 14.96 1.51 15.55 1.5 15.97 1.64 16.3 1.78L16.47 1.86 16.71 0.33" />
            <path d="M21.3 0.16L19.92 0.16C19.49 0.16 19.17 0.29 18.98 0.75L16.32 7.24 18.2 7.24C18.2 7.24 18.51 6.37 18.58 6.17 18.78 6.17 20.61 6.18 20.87 6.18 20.92 6.42 21.09 7.24 21.09 7.24L22.75 7.24 21.3 0.16 21.3 0.16ZM19.09 4.73C19.24 4.32 19.81 2.75 19.81 2.75 19.8 2.76 19.95 2.34 20.04 2.07L20.16 2.68C20.16 2.68 20.51 4.37 20.58 4.73L19.09 4.73 19.09 4.73Z" />
            <path d="M4.85 3.85L5.04 4.83 6.79 0 8.69 0 5.87 7.07 3.97 7.07 2.38 0.92C1.83 0.6 1.2 0.33 0.5 0.15L0.52 0 3.41 0C3.8 0.02 4.12 0.15 4.22 0.6L4.85 3.85Z" />
          </g>
          <path
            d="M0 4L32 4 32 1.01C32 0.44 31.56 0 31.01 0L0.99 0C0.45 0 0 0.45 0 1.01L0 4Z"
            fill="#1A1F71"
          />
          <path
            d="M0 17.86L0 17.86 0 20.85C0 21.41 0.44 21.86 0.99 21.86L31.01 21.86C31.55 21.86 32 21.41 32 20.85L32 17.86 0 17.86Z"
            fill="#F7B600"
          />
        </g>
      </svg>
    );
  }
}

export default Visa;



// WEBPACK FOOTER //
// ./src/js/Cio/Assets/Visa.js